//import Expressions from './screens/index.vue';
const Expressions = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const expressionsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.EXPRESSION_VIEW,
    PERMISSIONS_KEYS.EXPRESSION_INSERT,
    PERMISSIONS_KEYS.EXPRESSION_EDIT,
    PERMISSIONS_KEYS.EXPRESSION_DELETE,
  ])
) {
  expressionsRoutes.push({
    path: '/regras-da-prescricao/expressoes',
    name: 'Administração|Expressão',
    component: Expressions,
    meta: {
      icon: 'fa-cog',
      requiresAuth: true,
    },
  });
}

export { expressionsRoutes };
